import { render, staticRenderFns } from "./RequireText.vue?vue&type=template&id=2eaccfd9&"
import script from "./RequireText.vue?vue&type=script&lang=js&"
export * from "./RequireText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports